'use strict';
module.exports = require('../../full/number/is-integer');
